
<main>
    <div class="jobs">
        <div class="post-job cursorClass">
            <a (click)="addEditEvent('Add')" *ngIf="userTypeId == 1">
                <i class="ti ti-circle-plus"></i>
                <h4>કાર્યક્રમ નોંધણી કરો</h4>
            </a>
        </div>
        <h4>કાર્યક્રમ યાદી</h4>
        <hr>
        <div class="filtering">
            <form>
                <input placeholder="શોધો..." type="search" #filter (keyup)="applyFilter($event)" 
                class="form-control" aria-label="Search box">
                <i class="ti ti-search"></i>
            </form>
           
            <a class="ti ti-refresh cursorClass" (click)="getEventListData()"></a>
        </div>
         <div> 
            <div class="main-members">
                <a class="member-list-item" *ngFor="let data of getEventList">
                    <div class="flex1" (click)="goToSubEvent(data.event_id)">
                        <h5>{{data.event_name}}</h5>
                    </div>

                    <i class="ti ti-pencil" (click)="addEditEvent('Edit',data)"  *ngIf="userTypeId == 1"></i>
                    <!-- <i class="ti ti-trash" (click)="openDialog(data.business_id)"></i> -->
                </a>
            </div>
         </div> 
    </div>
</main>